import { TypographyH1, TypographyH2 } from "@/components/ui/typography"
import styles from "./styles.module.scss"
import { useAutoTranslation, useModalStore, useUserStore } from "@/entities"
import { capitalize } from "@/shared/utils"
import { Modal, UserPlan } from "@/shared/types"
import { Button } from "@/components/ui/button"
import { ListenUntilModal } from "@/widgets"
import { stripeControllerBillingPortal } from "@/shared/api/generated"
import { NewCheckoutSessionDtoReqPeriod } from "@/shared/api/generated"
import { useEffect, useState } from "react"
import { toast } from "sonner"
import {
  DISCOVERED_TRANSLATION_KEYS,
} from "@/shared/constants"

const ManageSubscriptionBtn = () => {
  const { t } = useAutoTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const manageSubscription = async () => {
    setIsLoading(true)
    const { url } = await stripeControllerBillingPortal()
    setIsLoading(false)
    if (!url) {
      toast.error(t(DISCOVERED_TRANSLATION_KEYS.FAILED_TO_OPEN_BILLING_PORTAL))
      return
    }
    window.open(url, "_blank")
  }

  return (
    <div className="mt-4">
      <Button onClick={manageSubscription} isLoading={isLoading}>
        {t(DISCOVERED_TRANSLATION_KEYS.MANAGE_SUBSCRIPTION)}
      </Button>
    </div>
  )
}

export const ManageSubscriptionPage = () => {
  const { t } = useAutoTranslation()
  const plan = useUserStore(s => s.plan)
  const openModal = useModalStore(s => s.openModal)

  useEffect(() => {
    const url = new URL(window.location.href)
    if (url.searchParams.get("paywall") !== "1") return

    const initialPeriod =
      url.searchParams.get("period") === NewCheckoutSessionDtoReqPeriod.MONTH
        ? NewCheckoutSessionDtoReqPeriod.MONTH
        : NewCheckoutSessionDtoReqPeriod.YEAR

    url.searchParams.delete("paywall")
    url.searchParams.delete("period")
    window.history.replaceState(window.history.state, "", url)

    if (plan === UserPlan.FREE) {
      openModal(
        Modal.LISTEN_UNTIL,
        <ListenUntilModal initialPeriod={initialPeriod} />
      )
    }
  }, [openModal, plan])

  const handleUpgradeToPremium = () => {
    openModal(Modal.LISTEN_UNTIL, <ListenUntilModal />)
  }

  return (
    <div className={styles.page}>
      <TypographyH1 className="mb-2 text-left text-2xl">
        {t(DISCOVERED_TRANSLATION_KEYS.MANAGE_SUBSCRIPTION)}
      </TypographyH1>

      <TypographyH2 className="text-xl">
        {t(DISCOVERED_TRANSLATION_KEYS.CURRENT_PLAN)} {capitalize(plan)}
      </TypographyH2>

      {plan === UserPlan.FREE && (
        <div className="mt-4">
          <Button onClick={handleUpgradeToPremium}>
            {t(DISCOVERED_TRANSLATION_KEYS.UPGRADE_TO_PREMIUM)}
          </Button>
        </div>
      )}

      {plan === UserPlan.PRO && <ManageSubscriptionBtn />}
    </div>
  )
}
